import { useQuery } from '@apollo/client';
import { Fancybox } from '@fancyapps/ui';
import { Grid } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { GET_FILE_URL } from 'schemas/query';
Fancybox.bind('[data-fancybox="gallery"]');
const AttachmentBox = ({ attachmentUrl, type, name }) => {
    return (
        <div className="thumbnail-wrapper">
            {(type == 'png' || type == 'jpg' || type == 'jpeg') && (
                <div className="thumbnail-inner">
                    <img src={attachmentUrl} alt="attachment" />
                </div>
            )}
            {type == 'pdf' && (
                <div className="thumbnail-inner bg-gray">
                    <PictureAsPdfOutlinedIcon />
                </div>
            )}
            {name && <div className="thumbnail-title">{name}</div>}
        </div>
    );
};
const SingleAttachment = ({ path, preview = true, removeImage }) => {
    let type = '';
    let attachmentUrl = '';
    const { data } = useQuery(GET_FILE_URL, {
        fetchPolicy: 'network-only', // Used for first execution
        nextFetchPolicy: 'cache-first',
        variables: {
            key: path
        }
    });
    if (data && data.getSignedUrlFromKey && data.getSignedUrlFromKey.signedUrl) {
        attachmentUrl = data.getSignedUrlFromKey.signedUrl;
        type = attachmentUrl.split(/[#?]/)[0].split('.').pop().trim();
    }
    let name = path?.split('/').pop();
    name = name?.split('_') ? name?.split('_')[0] : name;
    name = name + '.' + type;
    return (
        <>
            {attachmentUrl && (
                <Grid item sx={{ mb: 0.5 }} md={4}>
                    <div className="thumbnail">
                        {removeImage && (
                            <button type="button" className="cross" onClick={() => removeImage()}>
                                <CloseOutlinedIcon />
                            </button>
                        )}
                        {preview === true && (
                            <a href={attachmentUrl} data-fancybox="gallery">
                                <AttachmentBox attachmentUrl={attachmentUrl} type={type} name={name} />
                            </a>
                        )}
                        {preview === false && <AttachmentBox attachmentUrl={attachmentUrl} type={type} name={name} />}
                    </div>
                </Grid>
            )}
        </>
    );
};
export default SingleAttachment;
